import React from "react";

const Loader = () => {
  return (
    <div>
      <ul className="pl-6 mt-10 space-y-2">
        {[...Array(3).keys()].map((i) => (
          <li key={`${i}_loader`}>
            <span
              className="inline-block h-7 w-full bg-slate-200 animate-pulse"
              style={{
                animationDelay: `${i * 0.05}s`,
                animationDuration: "1.5s",
              }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Loader;
